import React from "react";
import { FaArrowLeft, FaBars, FaPercent, FaMoneyBill } from "react-icons/fa";
import * as SCREENS from "../../constants/screens";
import { useBlueBody } from "../../hooks/useBlueBody";
import Button from "./button";

export default function ServopaOptions({ dataManager, sidebarManager }) {
  const { data, setData } = dataManager;
  const { openSidebar } = sidebarManager;
  useBlueBody();

  function prevScreen() {
    setData({ ...data, screen: SCREENS.ADMINISTRATORS });
  }

  function nextScreen(mode) {
    setData({
      ...data,
      servopa_mode: mode,
      screen: SCREENS.NAME,
    });
  }

  return (
    <section className="administrators-screen">
      <div className="container mb-5">
        <div className="row justify-content-between align-items-center">
          <div className="col-auto">
            <FaArrowLeft
              role="button"
              className="icon-bar"
              onClick={prevScreen}
            />
          </div>
          <div className="col-8">
            <div className="progress">
              <div
                className="progress-bar"
                style={{ width: "30%" }}
                role="progressbar"
                aria-label="Progress Bar"
                aria-valuenow="30"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
          </div>
          <div className="col-auto">
            <FaBars role="button" className="icon-bar" onClick={openSidebar} />
          </div>
        </div>
      </div>
      <div className="container mb-5">
        <h1>Consórcio Sevopa</h1>
        <h2>Selecione o modo de simulação.</h2>
      </div>
      <div className="bottom-panel container">
            <div className="row">
                <Button name={"Meia Parcela"} icon={<FaPercent size={24}/>} nextScreen={() => nextScreen(1)}/>
                <Button name={"Contemplação"} icon={<FaMoneyBill size={24} />} nextScreen={() => nextScreen(2)}/>
            </div>
        </div>
    </section>
  );
}
